import { useState } from 'react';
import { AxiosError } from 'axios';
import toast from 'react-hot-toast';
import useHttps from '../useHttps';
import {
  HttpConfig,
  SuccessHttpResponse,
  ErrorHttpResponse,
} from '../../models/https';
import { useDispatch } from 'react-redux';
import { jobCreatedListActions } from '../../redux/slices/jobCreatedListSlice';
import { useAppSelector } from '../../redux/store';

const useEditJob = (jobId: string) => {
  const [loading, setLoading] = useState(false);
  const [edited, setEdited] = useState(false);
  const request = useHttps();
  const dispatch = useDispatch();

  // Use your Redux selector to find the permission for this job.
  const jobPermission = useAppSelector((state) =>
    state.jobPermissions.permissions.find((perm) => perm.jobId === jobId)
  );

  // Function to edit a job, accepting the updated job data.
  const editJob = async (updatedJobData: any) => {
    setLoading(true);
    if (!jobPermission?.canEdit) {
      toast.error('Cannot edit job with active applicants');
      setLoading(false);
      return;
    }

    // Convert pay and yearsOfExperience to numbers
    const payload = {
      ...updatedJobData,
      pay: Number(updatedJobData.pay),
      yearsOfExperience: Number(updatedJobData.yearsOfExperience),
    };

    try {
      const config: HttpConfig = {
        url: `jobs-service/jobs/${jobId}`,
        method: 'patch',
        data: payload,
      };

      const onSuccess = ({ data }: SuccessHttpResponse<any>) => {
        toast.success('Job edited successfully!');
        setLoading(false);
        setEdited(true);
        dispatch(jobCreatedListActions.editJob(data));
        return data;
      };

      const onError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(err?.response?.data?.message ?? 'Failed to edit job');
        setLoading(false);
        setEdited(false);
        throw err;
      };

      return request(config, onSuccess, setLoading, onError);
    } catch (error) {
      setLoading(false);
      setEdited(false);
      throw error;
    }
  };

  return {
    edited,
    loading,
    editJob,
  };
};

export default useEditJob;
